import { render, staticRenderFns } from "./GradientLegendHeaderRainfallDropdown.vue?vue&type=template&id=12e26d08&scoped=true"
import script from "./GradientLegendHeaderRainfallDropdown.vue?vue&type=script&lang=ts"
export * from "./GradientLegendHeaderRainfallDropdown.vue?vue&type=script&lang=ts"
import style0 from "./GradientLegendHeaderRainfallDropdown.vue?vue&type=style&index=0&id=12e26d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e26d08",
  null
  
)

export default component.exports